/**
 * 红包弹框
 */


import redPacket from './index.vue';
export { redPacket };
export default redPacket;